import usePurchaseErrors from 'features/FeatureManager/hooks/usePurchaseError'

const PurchaseError = () => {
    const puchaseError = usePurchaseErrors()
    return <>{puchaseError}</>
}


export default PurchaseError
